import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, FlameIcon } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/bMSa1hd5iwFXLEwtaEe5MG/TARJETAS_PILATES_SIN_FONDO.png';
interface HeroProps {
  onCta: () => void;
}
export function Hero({
  onCta
}: HeroProps) {
  return <section className="w-full overflow-visible bg-beige" data-id="element-64" data-mp="4mrul1r1q1lr">
      <div className="mx-auto w-full max-w-3xl px-6 pt-14 pb-12 text-center sm:w-[70%] sm:max-w-none sm:pt-16" data-id="element-65" data-mp="129h2fs8fj8fj">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-5 inline-block rounded-full bg-beige-deep px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-brown-light" data-id="element-66" data-mp="xanqi48sjphh">
          Pilates Resuelto
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="font-serif font-semibold text-brown-dark sm:text-5xl md:text-6xl text-[32px]" data-id="element-67" data-mp="3d33h34xud5nx">
          Dejá de improvisar tus clases de pilates.
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.12
      }} src={PRODUCT_IMAGE} alt="Colección Pilates Resuelto: tomos, recursos y elementos de pilates" className="mx-auto block w-[70%] max-w-sm object-contain" data-id="element-68" data-mp="3o73ouahgps7j" />

        <motion.p initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.18
      }} className="mx-auto max-w-xl text-brown-dark/75 sm:text-lg text-[16px]" data-id="element-69" data-mp="3599jq7jgg0uf">
          La colección para profes de pilates que quieren planificar mejor, adaptar con confianza y dejar de improvisar.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="mt-6 flex items-center justify-center gap-2" data-id="element-70" data-mp="2hjynn3d1uumm">
          <div className="flex text-brown-light" data-id="element-71" data-mp="nbl4gqm0mqd3">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" strokeWidth={0} data-id="element-72" data-mp="ibyoi9esyw0l" data-mpi={i} />)}
          </div>
          <span className="text-sm font-semibold text-brown-dark" data-id="element-73" data-mp="ddwx91783qe1">
            4.9/5 estrellas
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.32
      }} className="mt-8" data-id="element-74" data-mp="1b0du65c1o1z9">
          <button onClick={onCta} className="rounded-full bg-brown-dark px-9 py-4 text-sm font-bold uppercase tracking-wide text-beige shadow-lg shadow-brown-dark/20 transition-transform hover:scale-[1.03] active:scale-95" data-id="element-75" data-mp="11150ldl3cpdf">
            Quiero mis clases resueltas
          </button>
          <p className="mt-4 flex items-center justify-center gap-2 text-sm font-medium text-brown-light" data-id="element-76" data-mp="3htg8y6pi0hht">
            <FlameIcon className="h-4 w-4" data-id="element-77" data-mp="1x7hv3bmtnyzt" />
            Oferta especial por tiempo limitado
          </p>
        </motion.div>
      </div>
    </section>;
}